import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=27828b83&scoped=true&"
import script from "./FeedbackPage.vue?vue&type=script&lang=js&"
export * from "./FeedbackPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPage.vue?vue&type=style&index=0&id=27828b83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27828b83",
  null
  
)

export default component.exports